module.exports = __webpack_public_path__ + "static/userrolesimage-eb7d92afc3405f6df9590a34a4983b0a.png";